<app-form-wrapper title="Audience">
  <div class="pv">
    <!-- Unique people reached, counted once each -->
    <div class="pv__figure" aria-live="polite">
      @if (audience.empty) {
        <span class="pv__number">0</span>
        <span class="pv__caption">Choose a group to see how many people it reaches.</span>
      } @else if (audience.loading && audience.count === null) {
        <span class="bk-skel pv__skel-number" aria-label="Counting recipients"></span>
        <span class="bk-skel pv__skel-line"></span>
      } @else if (audience.failed) {
        <p class="pv__note pv__note--bad">
          <span class="bk-sym" aria-hidden="true">error</span>
          <span>Couldn’t count the recipients. Check your connection and try again.</span>
        </p>
        <div class="pv__actions">
          <button type="button" class="bk-btn bk-btn--ghost" (click)="audience.refresh(true)">Count again</button>
        </div>
      } @else if (audience.count !== null) {
        <span class="pv__number" [class.is-zero]="audience.count === 0">{{ formatCount(audience.count) }}</span>
        <span class="pv__caption">
          @if (audience.count === 0) {
            These groups have no contacts yet. Add contacts or choose other groups.
          } @else {
            unique {{ audience.count === 1 ? "person" : "people" }}{{ audience.loading ? ", recounting…" : "" }}
          }
        </span>
        @if (audience.count === 0) {
          <div class="pv__actions">
            <button type="button" class="bk-btn bk-btn--ghost" [disabled]="audience.loading" (click)="audience.refresh(true)">
              {{ audience.loading ? "Counting…" : "Count again" }}
            </button>
          </div>
        }
      }
    </div>

    <hr class="pv__divider" />

    <div class="pv__fact">
      <p class="pv__label">Organizations</p>
      @if (recipients.recipients.organizations.length) {
        <div class="pv__chips">
          @for (item of recipients.recipients.organizations; track $index) {
            <span class="bk-chip">{{ item.name }}</span>
          }
        </div>
      } @else {
        <p class="pv__empty">None</p>
      }
    </div>

    <div class="pv__fact">
      <p class="pv__label">Tags</p>
      @if (recipients.recipients.tags.length) {
        <div class="pv__chips">
          @for (item of recipients.recipients.tags; track $index) {
            <span class="bk-chip">{{ item.name }}</span>
          }
        </div>
      } @else {
        <p class="pv__empty">None</p>
      }
    </div>

    <div class="pv__fact">
      <p class="pv__label">Segments</p>
      @if (recipients.recipients.segments.length) {
        <div class="pv__chips">
          @for (item of recipients.recipients.segments; track $index) {
            <span class="bk-chip">{{ item.name }}</span>
          }
        </div>
      } @else {
        <p class="pv__empty">None</p>
      }
    </div>
  </div>
</app-form-wrapper>
